import { useEffect, useRef } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Music from './components/Music';
import Gallery from './components/Gallery';
import Contact from './components/Contact';

export default function HomePage() {
  const hexGridRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = hexGridRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    let animationFrame: number;
    let offset = 0;

    const drawHexagon = (x: number, y: number, size: number, opacity: number) => {
      ctx.beginPath();
      for (let i = 0; i < 6; i++) {
        const angle = (Math.PI / 3) * i;
        const hx = x + size * Math.cos(angle);
        const hy = y + size * Math.sin(angle);
        if (i === 0) {
          ctx.moveTo(hx, hy);
        } else {
          ctx.lineTo(hx, hy);
        }
      }
      ctx.closePath();
      ctx.strokeStyle = `rgba(255, 255, 255, ${opacity})`;
      ctx.lineWidth = 1.5;
      ctx.stroke();
    };

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      const hexSize = 50;
      const hexWidth = hexSize * Math.sqrt(3);
      const hexHeight = hexSize * 2;
      
      offset += 0.3;
      if (offset > hexHeight * 0.75) offset = 0;

      for (let row = -2; row < Math.ceil(canvas.height / (hexHeight * 0.75)) + 2; row++) {
        for (let col = -2; col < Math.ceil(canvas.width / hexWidth) + 2; col++) {
          const x = col * hexWidth + (row % 2) * (hexWidth / 2);
          const y = row * hexHeight * 0.75 - offset;
          
          const distanceFromCenter = Math.sqrt(
            Math.pow(x - canvas.width / 2, 2) + Math.pow(y - canvas.height / 2, 2)
          );
          const maxDistance = Math.sqrt(
            Math.pow(canvas.width / 2, 2) + Math.pow(canvas.height / 2, 2)
          );
          const opacity = 0.08 + (1 - distanceFromCenter / maxDistance) * 0.12;
          
          drawHexagon(x, y, hexSize, opacity);
        }
      }

      animationFrame = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      cancelAnimationFrame(animationFrame);
    };
  }, []);

  return (
    <div className="relative bg-black text-white">
      <canvas
        ref={hexGridRef}
        className="fixed top-0 left-0 w-full h-full pointer-events-none z-0"
      />
      
      <div className="relative z-10">
        <Hero />
        <About />
        <Music />
        <Gallery />
        <Contact />
      </div>
    </div>
  );
}
